












































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import Select from '@/components/Select.vue'
import Icon from '@/components/Icon.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { ResidentModule } from '@/store/modules/resident.module'
import {
  EPaymentStatus,
  IPayment,
  IPaymentStatus,
  IResident,
  IPaymentsFiltersDTO,
  EUserPermissions, IAutoPayItem, IResidentPaymentMethod, EPaymentMethodType, IFacility
} from '@zunta/configurations'
import { getPaidByLabel, formatTransactionEffectiveDate } from '@/utils/helpers'
import RefundPopup from '@/views/app/management/components/RefundPopup.vue'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import Card from '@/components/Card.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Table from '@/components/tables/Table.vue'
import PaymentProcessedSubrow from '@/views/app/management/payments/components/PaymentProcessedSubrow.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusPayment from '@/components/statuses/StatusPayment.vue'
import { PAYMENT_STATUSES_LABEL_MAP } from '@/constants'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
// @ts-ignore
import Teleport from 'vue2-teleport'

@Component({
  components: {
    ButtonDownloadReport,
    PaymentMethodLabel,
    StatusPayment,
    PaymentProcessedSubrow,
    Table,
    Card,
    FacilityLabel,
    ResidentLabel,
    Select,
    SearchInput,
    DateInput,
    Icon,
    AddressesPopup,
    RefundPopup,
    DateTimeLabel,
    Teleport
  }
})
export default class PaymentsProcessed extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  formatTransactionEffectiveDate: Function = formatTransactionEffectiveDate
  getPaidByLabel: Function = getPaidByLabel
  EUserPermissions: any = EUserPermissions
  EPaymentStatus: any = EPaymentStatus
  user: User = Api.getUser() as User

  filters: IPaymentsFiltersDTO = {
    skip: 0,
    limit: 20
  }

  openedRow: any = null
  openedRowIndex: any = -1

  receiptPaymentId: number = -1

  refundPayment: any = null

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: -1.5rem; right: -1.5rem;',
      class: 'rounded-top-bottom'
    },
    useQuery: true,
    usePagination: true,
    useSubrow: true,
    fetchFunction: this.paymentsModuleInstance.getPaymentsList,
    rowClick: this.openSubrow,
    maxHeight: 'calc(100vh - 392px)',
    minHeight: '100px',
    columns: [
      {
        minWidth: '60px',
        width: 6,
        key: 'willowPaymentId',
        searchKey: 'willowPaymentId',
        label: 'Payment Id',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 8,
        key: 'facility',
        searchKey: 'facility',
        label: 'Facility',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 10,
        key: 'resident',
        searchKey: 'resident',
        label: 'Resident',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '140px',
        width: 14,
        key: 'paymentMethod',
        searchKey: 'paymentMethod',
        label: 'Payment Method',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'processedBy',
        searchKey: 'processedBy',
        label: 'Processed By',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '100px',
        width: 10,
        key: 'amountPaid',
        searchKey: 'amountPaid',
        label: 'Amount',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'paidDate',
        searchKey: 'paidDate',
        label: 'Date',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '100px',
        width: 9,
        key: 'willowDepositId',
        searchKey: 'willowDepositId',
        label: 'Deposit Id',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '130px',
        width: 13,
        key: 'status',
        searchKey: 'status',
        label: 'Status',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.multiselect,
        options: this.allowedStatuses
      },
      {
        class: 'text-right',
        minWidth: '170px',
        width: 10,
        key: 'actions'
      }
    ]
  }

  get paymentsList () {
    return this.$store.state.payments.paymentStatusList
  }

  get recordsTotal () {
    return this.$store.state.payments.total
  }

  get isUserCanRefund (): boolean {
    return this.user.hasPermissionFor(EUserPermissions.REFUND_PAYMENT)
  }

  openSubrow (row: any, index: number) {
    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      return
    }
    this.openedRowIndex = index
    this.openedRow = row
  }

  showNotInOrigin (paymentStatus: any) {
    const notSync = !paymentStatus.payment.isSync
    const notHmo = !paymentStatus.payment.hmo
    const isDeclineOrVoid = [EPaymentStatus.DECLINED, EPaymentStatus.VOIDED].includes(paymentStatus.status)
    const isEcheckReject = paymentStatus.payment.residentPaymentMethod && paymentStatus.payment.residentPaymentMethod.type === 'ECHECK' && paymentStatus.payment.rejectPayment
    return notSync && notHmo && !(isDeclineOrVoid && !isEcheckReject)
  }

  getLocaleDate (date: any) {
    // @ts-ignore
    return new Date(date).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' })
  }

  get allowedStatuses () {
    return Object.values(EPaymentStatus).map((status: string) => ({
      content: PAYMENT_STATUSES_LABEL_MAP[status],
      key: status,
      value: status
    }))
  }

  goToAndRememberRoute (options: any) {
    this.$locationManager.rememberAndGoTo(options)
  }

  async fetchPaymentTransactions (paymentId: number) {
    await this.paymentsModuleInstance.getPaymentTransactions(paymentId)
    await this.paymentsModuleInstance.getRejectTransactions(paymentId)
  }

  goToEditPayment (paymentStatus: IPaymentStatus) {
    const payment = paymentStatus.payment as IPayment
    const resident = payment.resident as IResident
    this.goToAndRememberRoute({
      name: 'payment-one-time-edit',
      params: {
        residentId: resident.id,
        paymentId: payment.id
      }
    })
  }

  showRefundPopup (payment: IPayment) {
    if (this.isUserCanRefund) {
      this.refundPayment = payment
    }
  }

  closeRefundPopup () {
    this.refundPayment = null
  }

  async showReceipt (payment: IPayment) {
    if (payment.resident) {
      this.residentModuleInstance.fetchResidentContacts((payment.resident as IResident).id)
    }
    this.receiptPaymentId = payment.id
  }

  closeReceiptPopup () {
    this.receiptPaymentId = -1
  }

  showRefundButton (item: IPaymentStatus) {
    const payment = item.payment as IPayment
    if (!this.isUserCanRefund || this.user.isResident() || payment.initialPaymentId) {
      return false
    }
    if ([EPaymentStatus.VOIDED, EPaymentStatus.DECLINED, EPaymentStatus.REFUNDED].includes(item.status)) {
      return false
    }
    if ((payment.residentPaymentMethod as IResidentPaymentMethod).type === EPaymentMethodType.CREDIT_CARD &&
      !(payment.facility as IFacility).allowCCProcessing) {
      return false
    }
    return true
  }
}
